(function () {
  "use strict";

  let observerEl = document.querySelector(".observer");
  let holder = document.querySelector(".gallery-holder");
  let currentPage = 1;
  let apiState = false;

  if (observerEl) {
    let observer = new IntersectionObserver(
      function (entries) {
        if (entries[0].isIntersecting) {
          if (apiState) return;
          apiState = true;
          fetch("/gallery/get?page=" + (currentPage + 1))
            .then(function (res) {
              return res.json();
            })
            .then(function (data) {
              if (data.state) {
                currentPage = parseInt(data.page);
                holder.innerHTML += galleryElCreator(data.galleries);
                if (!data.isNext) {
                  observerEl.style.display = "none";
                  observer.disconnect();
                  return;
                }
              }

              apiState = false;
            });
        }
      },
      {
        threshold: 1.0,
      }
    );

    observer.observe(document.querySelector(".observer"));
  }

  function galleryElCreator(data) {
    let html = "";
    data.forEach((gallery) => {
      html += ` <div class="gallery" style="background-image: url('/uploads/gallery/${gallery.img}')"></div>`;
    });

    return html;
  }

  $(".gallery-holder").on("click", ".gallery", function (e) {
    var src = $(this)
      .css("background-image")
      .replace("url(", "")
      .replace(")", "")
      .replace(/\"/gi, "");

    lity(src);
  });
})();
